import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "../../actions"
import { Redirect } from "react-router-dom"
import Modal from "react-responsive-modal"
import fieldStatus from "../../helpers/fieldStatus"
import submitData from "../../helpers/submitData"
import { Formik, Field, Form } from "formik"
import fields from "models/editUser"
import TextArea from "components/TextArea"
import * as Yup from "yup"
import nullToEmptyString from "helpers/nullToEmptyString"
import clone from "clone"
import _ from "lodash"
import ReactSelect from "components/ReactSelect"
import { toast } from "react-toastify"

class EditDevUser extends Component {
	constructor(props) {
		super(props)
		// Modules come from server, so this is put in place so these checkboxes stay controlled by formik, otherwise warnings thrown.
		let modules = {}
		let f = clone(fields)
		_.forEach(props.payload.public.loadedModules, (v, k) => {
			let key = v.id.toString()
			modules[key] = false
		})
		f.modules = modules
		//
		this.state = {
			ready: false,
			fields: f,
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.data !== this.props.data && this.props.data.id) {
			let data = clone(this.props.data)
			data = nullToEmptyString(data)
			let modules = {}
			//console.log(data)
			_.forEach(this.props.payload.public.loadedModules, (v) => {
				if (data.modules.includes(v.id) || data.modules.includes("*")) {
					modules[v.id] = true
				} else {
					modules[v.id] = false
				}
			})
			//console.log(modules)
			this.setState({
				fields: {
					first: data.first,
					last: data.last,
					email: data.email,
					properties: data.properties,
					builders: data.builders,
					notes: data.notes,
					modules: modules,
					status: data.status,
					viewAsPermission: data.viewAsPermission,
					password: "",
					superUser: data.modules[0] === "*" ? 1 : 0,
				},
				ready: true,
			})
		}
		return null
	}

	validation = () => {
		return Yup.object().shape({
			first: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
			last: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
			email: Yup.string().email("Invalid email address").required("Required"),
			status: Yup.number().required("Required"),
			properties: Yup.array().min(1, "Please select at least one property.").required("Required"),
			//password: Yup.string().notRequired(),
		})
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	checkAll = (f, status) => {
		_.forEach(f.values.modules, (v, k) => {
			//f.values.modules[k] = status
			f.setFieldValue(`modules[${k}]`, status)
		})
	}

	generateModules = (f) => {
		let parents = _.filter(this.props.payload.public.loadedModules, (v) => v.is_parent === 1)
		parents = _.sortBy(parents, "order")
		_.forEach(parents, (v) => {
			v.children = []
		})
		let children = _.filter(this.props.payload.public.loadedModules, (v) => !v.is_parent)
		children = _.sortBy(children, "order")
		_.forEach(children, (v) => {
			let ind = _.findIndex(parents, { id: v.parent })
			if (ind !== -1) {
				parents[ind].children.push(v)
			}
		})
		//console.log(parents)
		return _.map(parents, (v, k) => {
			let id = v.id.toString()
			let c = _.map(v.children, row => {
				return (
					<div
						className="editUser__module editUser__module--child"
						key={row.id}>
						<div>{row.name}</div>
						<div>
							<Field name={`modules[${row.id}]`} type="checkbox" checked={f.values.modules[row.id]} />
						</div>
					</div>
				)
			})
			// Some top levels are components, some aren't.
			let field
			if(v.component) {
				field = <Field name={`modules[${v.id}]`} type="checkbox" checked={f.values.modules[v.id]} />
			}
			return (
				<>
					<div
						className="editUser__module editUser__module--parent"
						key={v.id}>
						<div>{v.name}</div>
						<div>{field}</div>
					</div>
					{c}
				</>
			)
		})
	}

	render() {
		const { open } = this.props
		if (this.state.redirect) {
			return <Redirect to={this.state.redirectPath} />
		} else if (this.props.payloadStatus) {
			let properties = _.map(this.props.payload.public.properties, (v) => {
				return { label: v.name, value: v.id }
			})
			return (
				<div>
					<Modal open={open} onClose={this.props.onClose} center>
						<h3>Edit {`${this.props.data.first} ${this.props.data.last}`}</h3>
						<Formik
							enableReinitialize
							initialValues={this.state.fields}
							validateOnMount={true}
							validationSchema={this.validation}
							onSubmit={(values) => {
								this.props.loadingStatus(true)
								if(values.superUser === 1) {
									values.modules = ["*"]
								}
								values.id = this.props.data.id
								delete values.superUser
								delete values.password
								//console.log(values)
								//return
								submitData("editDevUser", values).then((data) => {
									this.props.loadingStatus(false)
									toast.success(data.message)
									this.props.close()
									this.setState(
										{
											redirect: true,
											redirectPath: data.redirect,
										},
										() => {
											this.props.getPayload()
										}
									)
								})
							}}>
							{(f) => (
								<div className="editUser">
									<div className="content">
										<Form>
											{/* console.log(f) */}
											<ul className="form__list">
												<li className={fieldStatus("first", f)}>
													<label htmlFor="first">First Name *</label>
													{f.errors.first && f.touched.first && (
														<div className="form__message">{f.errors.first}</div>
													)}
													<Field name="first" type="text" className="form__input" />
												</li>
												<li className={fieldStatus("last", f)}>
													<label htmlFor="last">Last Name *</label>
													{f.errors.last && f.touched.last && (
														<div className="form__message">{f.errors.last}</div>
													)}
													<Field name="last" type="text" className="form__input" />
												</li>
												{/* <li className={fieldStatus("password", f)}>
													<label htmlFor="password">Password</label>
													{f.errors.password && f.touched.password && (
														<div className="form__message">{f.errors.password}</div>
													)}
													<Field name="password" type="password" className="form__input" />
												</li> */}
												<li className={fieldStatus("email", f)}>
													<label htmlFor="email">Email *</label>
													{f.errors.email && f.touched.email && (
														<div className="form__message">{f.errors.email}</div>
													)}
													<Field name="email" type="email" className="form__input" />
												</li>
												<li className={fieldStatus("status", f)}>
													<label htmlFor="status">
														Status <sup>*</sup>
													</label>
													{f.errors.status && f.touched.status && (
														<div className="form__message">{f.errors.status}</div>
													)}
													<ReactSelect
														name={`status`}
														options={[
															{ value: 0, label: "Disabled" },
															{ value: 1, label: "Enabled" },
														]}
														value={f.values.status}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("viewAsPermission", f)}>
													<label htmlFor="viewAsPermission">
														View As Salesperson <sup>*</sup>
													</label>
													{f.errors.viewAsPermission && f.touched.viewAsPermission && (
														<div className="form__message">{f.errors.viewAsPermission}</div>
													)}
													<ReactSelect
														name={`viewAsPermission`}
														options={[
															{ value: 0, label: "No" },
															{ value: 1, label: "Yes" },
														]}
														value={f.values.viewAsPermission}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("superUser", f)}>
													<label htmlFor="superUser">
														Super User
													</label>
													{f.errors.superUser && f.touched.superUser && (
														<div className="form__message">{f.errors.superUser}</div>
													)}
													<ReactSelect
														name={`superUser`}
														options={[
															{ value: 0, label: "No" },
															{ value: 1, label: "Yes" },
														]}
														value={f.values.superUser}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("properties", f, false, false, true)}>
													<label htmlFor="properties">
														Properties <sup>*</sup>
													</label>
													{f.errors.properties && f.touched.properties && (
														<div className="form__message">{f.errors.properties}</div>
													)}
													<ReactSelect
														name={`properties`}
														options={properties}
														isMulti
														selectAll
														value={f.values.properties}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("notes", f, false, false, true)}>
													<label htmlFor="notes">Notes</label>
													{f.errors.notes && f.touched.notes && (
														<div className="form__message">{f.errors.notes}</div>
													)}
													<TextArea
														name="notes"
														className="form__textarea"
														value={f.values.notes}
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.notes}
														error={f.errors.notes}
													/>
												</li>
											</ul>
											<div className="editUser__modules">
												<h3>Assigned Modules</h3>
												<p className="filterCheck">
													<span onClick={() => this.checkAll(f, true)}>Check All</span>
													<span onClick={() => this.checkAll(f, false)}>Uncheck All</span>
												</p>
												{this.generateModules(f)}
											</div>
											<input
												type="submit"
												value="Submit"
												className={this.submitClasses(f.isValid)}
											/>
										</Form>
									</div>
								</div>
							)}
						</Formik>
					</Modal>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(EditDevUser)
